import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { closePanels, hideContact, hideFaq, hidePrivateService, hideSectionBanner, hideServiceList, hideTeamsMenu, setSection, showContentSection } from '../features/serviceSlice';
import { toSlug } from '../utils/slug';
import "./privateServiceMenu.css"

const PrivateServiceMenu = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {
        serviceData,
        activeSection
    } = useSelector(state => state.service);
    return (
        <>
            <section className="private-services">
                <p className="eyebrow">AN OVERVIEW OF MEMBERSHIP SERVICE</p>

                <h1 className="main-title">
                    <span>Private</span> Services.
                </h1>

                {/* BLOCK 1 */}
                {serviceData?.map((x) =>
                    <div key={x.id} className="service-row">
                        <img
                            src={x.featured_image}
                            alt={x.title}
                        />

                        <div className="content">
                            <h3>{x.heading}</h3>
                            <p>
                                {x.short_description}
                            </p>
                            <button onClick={(e) => {
                                e.stopPropagation();
                                dispatch(showContentSection());
                                dispatch(setSection(x.title));
                                dispatch(hideTeamsMenu());
                                dispatch(closePanels());
                                dispatch(hideFaq());
                                dispatch(hideContact());
                                dispatch(hidePrivateService());
                                setTimeout(() => {
                                    dispatch(setSection(x.title));
                                }, 400)
                                if (activeSection !== x.title) {
                                    dispatch(hideSectionBanner());
                                    dispatch(hideServiceList());
                                    setTimeout(() => {
                                        navigate(`/services/${toSlug(x.title)}`);
                                    }, 900)
                                } else {
                                    navigate(`/services/${toSlug(x.title)}`);
                                }
                            }}>{x.button_text}</button>
                        </div>
                    </div>
                )}
            </section>
        </>
    )
}

export default PrivateServiceMenu
